import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'


const Navbar = () => {
  return (
    <Header>
        <div className="logo">
             <Link to="/"><h2>AMRS</h2></Link>
        </div>
    </Header>
  )
}

const Header = styled.header`
    padding: 1.5em 1.5em;
    .logo{
        width: 0%;
        letter-spacing: .1em;
        h2{
        color: var(--color-black);
        margin: 0;
    }
    }
`;

export default Navbar